import {
  laptopMediumMax,
  laptopMediumMin,
  largeTabletMax,
  tabletMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled, { css } from 'styled-components';
import { BadgeText } from '../property-box/PropertyBadge.style';
import { Container as FavouriteContainer } from '../property-box/PropertyFavourite.style';
import RichText from '../rich-text/RichText';
import { Heading } from '../typography';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;

  @media (${largeTabletMax}) {
    flex-direction: column;
  }
`;

export const SummaryBox = styled.div`
  position: relative;
  padding-right: 20px;
  flex: 1;

  // Allows custom colour on favourite icon
  button {
    color: inherit;
  }

  @media (${largeTabletMax}) {
    padding: 0;
    width: 100%;
  }
`;

export const TopBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  flex-flow: wrap-reverse;

  @media (${laptopMediumMin}) {
    align-items: center;
  }

  @media (${laptopMediumMax}) {
    flex-direction: column-reverse;
  }

  ${BadgeText} {
    font-size: 14px;
  }
`;

const IconStyle = css`
  span,
  svg {
    font-size: 17px;
    transition: color 150ms linear;
  }

  &:hover {
    span,
    svg {
      color: ${({ theme }) => theme.backgroundMid};
    }
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  row-gap: 10px;
  column-gap: 20px;

  @media (${laptopMediumMax}) {
    margin-bottom: 20px;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 0px;
  }

  ${FavouriteContainer} {
    ${IconStyle}
  }
`;

export const IconLink = styled(Link)`
  display: flex;
  align-items: center;

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.textDark};
  }

  ${IconStyle}
`;

export const IconContainer = styled(FavouriteContainer)`
  ${IconStyle}
`;

export const AddressHeader = styled(Heading)`
  @media (${tabletMax}) {
    font-size: 25px;
  }
`;

export const SummaryText = styled(RichText)<{ $hasBriefText: boolean }>`
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  ${({ $hasBriefText }) =>
    $hasBriefText &&
    css`
      padding-top: 15px;
      border-top: 1px solid ${({ theme }) => theme.black};
    `}
`;
